import type { GetNextRoomName } from "./types";

export const getNextRoomName: GetNextRoomName = ({
  existingNames,
  formatName,
}) => {
  const takenNames = new Set(existingNames);
  let index = 1;
  while (takenNames.has(formatName(index))) {
    index += 1;
  }
  return formatName(index);
};
